<button type="button"
        class="sms-trigger"
        [class.sms-trigger--collapsed]="collapsed"
        [class.sms-trigger--open]="open"
        [attr.aria-expanded]="open"
        [title]="collapsed ? label : ''"
        (click)="toggle($event)">
  <span class="sms-mark">
    @if (logoSrc && !logoFailed) {
      <img [src]="logoSrc" alt="" (error)="handleLogoError()" />
    } @else {
      <i class="fas fa-layer-group"></i>
    }
  </span>
  @if (!collapsed) {
    <span class="sms-copy">
      <span class="sms-brand">SPECTRUM</span>
      <span class="sms-module">{{ label }}</span>
    </span>
    <i class="fas fa-chevron-down sms-chevron" [class.sms-chevron--open]="open"></i>
  }
</button>

@if (open) {
  <div class="module-menu"
       [style.top.px]="panelTop"
       [style.left.px]="panelLeft"
       [style.width.px]="panelWidth"
       [style.max-height.px]="panelMaxHeight"
       (click)="$event.stopPropagation()">
    <div class="module-menu__header">
      <div class="module-menu__title">
        <span class="module-menu__title-icon">
          <i class="fas fa-layer-group"></i>
        </span>
        <div>
          <span class="module-menu__eyebrow">Switch Module</span>
          <strong>Choose workspace</strong>
        </div>
      </div>
      @if (currentModule) {
        <span class="module-menu__current">{{ currentModule!.moduleName }}</span>
      }
    </div>
    <div class="module-menu__meta">
      <span>{{ filteredModules.length }} shown</span>
      <span>{{ modules.length }} total modules</span>
    </div>
    <div class="module-menu__search">
      <i class="fas fa-search"></i>
      <input type="text" [(ngModel)]="search" placeholder="Search modules..." />
      @if (search) {
        <button type="button" (click)="search = ''">
          <i class="fas fa-times"></i>
        </button>
      }
    </div>
    <div class="module-menu__grid">
      @for (module of filteredModules; track module.moduleName) {
        <button
          class="module-menu__item"
          [class.module-menu__item--active]="isCurrent(module)"
          type="button"
          (click)="select(module)">
          @if (module.image) {
            <span class="module-menu__icon-shell">
              <img class="module-menu__icon-img" [src]="module.image" alt="" />
            </span>
          } @else {
            <span class="module-menu__icon module-menu__icon-shell">
              <i class="fas fa-cube"></i>
            </span>
          }
          <span class="module-menu__item-copy">
            <span class="module-menu__item-name">{{ module.moduleName }}</span>
          </span>
          @if (isCurrent(module)) {
            <span class="module-menu__check">
              <i class="fas fa-check"></i>
            </span>
          }
        </button>
      } @empty {
        <div class="module-menu__empty">
          <i class="fas fa-search"></i>
          <span>No modules found</span>
        </div>
      }
    </div>
  </div>
}
